import * as React from 'react';

function SvgCamera(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 15.57a2.857 2.857 0 100-5.715 2.857 2.857 0 000 5.715z" }),
        React.createElement("path", { fill: "currentColor", d: "M19.857 7h-2.634c-.134 0-.3-.087-.43-.223l-1.157-1.828a.691.691 0 00-.061-.083c-.4-.466-.941-.723-1.521-.723H9.946c-.58 0-1.12.257-1.52.723a.692.692 0 00-.062.083l-1.158 1.83c-.099.108-.238.223-.385.223v-.357a.714.714 0 00-.714-.714H5.036a.714.714 0 00-.715.714v.357h-.178A2.145 2.145 0 002 9.145v8.569a2.145 2.145 0 002.143 2.143h15.714A2.145 2.145 0 0022 17.714V9.143A2.145 2.145 0 0019.857 7zM12 17a4.285 4.285 0 110-8.57A4.285 4.285 0 0112 17z" })));
}

export default SvgCamera;
